import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["list"]
  static values = {
    urlTemplate: String,
    resourceName: String
  }

  connect() {
    console.log("Sortable controller connected")
    this.sortable = Sortable.create(this.listTarget, {
      animation: 150,
      onEnd: this.onEnd.bind(this)
    })
  }

  onEnd(event) {
    const { newIndex, item } = event
    const id = item.dataset.id
    const url = this.urlTemplateValue.replace(":id", id)

    const formData = new FormData()
    // The positioning gem uses 1-based indexing
    formData.append(`${this.resourceNameValue}[position]`, newIndex + 1)
    formData.append("from_sort", "true")

    fetch(url, {
      method: "PATCH",
      body: formData,
      headers: {
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
        "Accept": "text/html, application/xhtml+xml"
      }
    }).then(response => {
      if (response.ok) {
        // Trigger a Turbo morph refresh
        Turbo.visit(window.location.pathname, { action: "replace" })
      }
    })
  }
}
